var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5B3B9A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7593 12.2408C27.6021 12.0837 27.4059 11.9714 27.1909 11.9154C26.9758 11.8594 26.7497 11.8617 26.5359 11.9221H26.5242L11.5288 16.4721C11.2854 16.5422 11.069 16.6847 10.9084 16.8806C10.7478 17.0765 10.6504 17.3166 10.6293 17.5691C10.6082 17.8216 10.6644 18.0745 10.7903 18.2944C10.9162 18.5142 11.1059 18.6906 11.3343 18.8002L17.9687 22.0315L21.1952 28.6619C21.2956 28.8761 21.4552 29.0571 21.6551 29.1834C21.855 29.3098 22.0869 29.3764 22.3234 29.3752C22.3593 29.3752 22.3952 29.3736 22.4312 29.3705C22.6835 29.3501 22.9234 29.253 23.1189 29.0923C23.3144 28.9315 23.4561 28.7149 23.5249 28.4713L28.0718 13.476C28.0718 13.4721 28.0718 13.4682 28.0718 13.4643C28.133 13.251 28.1363 13.0252 28.0814 12.8102C28.0265 12.5952 27.9153 12.3987 27.7593 12.2408ZM22.3304 28.1135L22.3265 28.1244V28.119L19.1968 21.6893L22.9468 17.9393C23.0591 17.8211 23.1207 17.6638 23.1186 17.5008C23.1166 17.3378 23.0509 17.1821 22.9356 17.0668C22.8204 16.9516 22.6647 16.8859 22.5017 16.8838C22.3387 16.8818 22.1814 16.9434 22.0632 17.0557L18.3132 20.8057L11.8812 17.676H11.8757H11.8867L26.8749 13.1252L22.3304 28.1135Z",
    fill: "#5B3B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.e05cd10723c88c2c404ae7fa5ee3b3c4.svg";
export { ForwardRef as ReactComponent };